module.exports = __webpack_public_path__ + "img/empty_data.dcdf14e6.svg";